import { Component, ElementRef, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { Wishlist } from '@app/app/wishlist/iwishlist';
import { DialogService } from '@app/components/dialog/dialog.service';
import { DeviceService, EventTrackerService, HttpService, LogService } from '@app/core';
import { IndicatorService } from '@app/shared';
import { iNotification, NotificationService } from '@app/shared/notification/notification.service';
import { environment } from '@env/environment';

import { DialogArchiveItemComponent } from '../dialog-archive-item/dialog-archive-item.component';

@Component({
  selector: 'navaar-archives',
  templateUrl: './archives.component.html',
  styleUrls: ['./archives.component.scss']
})
export class ArchivesComponent implements OnInit {
  @ViewChildren('optionmenu', { read: ElementRef }) private optionmenus: QueryList<ElementRef>;
  public appVersionNotSupport: boolean = false;
  private categoryNameText: string = '';
  private Items: Array<Wishlist>;
  public FilteredItems = {};
  public isShowBtnBuy: boolean = false;
  public _environment = environment;
  public _showTab = [true, false, false, false];
  public searchText: string = '';
  public dataBadge: object = [];
  public maxRatingCount = [1, 2, 3, 4, 5];


  constructor(
    private readonly notification: NotificationService,
    public readonly device: DeviceService,
    private readonly indicator: IndicatorService,
    private readonly router: Router,
    private readonly log: LogService,
    private readonly dialog: DialogService,
    private readonly http: HttpService,
    private readonly eventTracker: EventTrackerService) {
    this.isShowBtnBuy = this.device.isCaffebazar();
  }

  ngOnInit(): void {
    this.getList();
  }

  public showTab(index) {
    this._showTab = this._showTab.map(c => false);
    this._showTab[index] = true;
  }

  public onShowNotification(e: iNotification) {
    this.notification.setNotification(e);
  }

  public gotoLibrary(productId, event, audiobookTitle) {
    event.stopPropagation();
    this.eventTracker.logEvent('x_direct_purchace', { location_screen: 'archive', x_title: audiobookTitle });

    this.log.logger('Sending purchase with ' + productId);
    this.device.purchaseBook(productId);
    this.indicator.hide();
  }

  public goToBook(id) {
    this.indicator.show();
    this.router.navigate(['/audiobook', id]);
  }

  public showOptionMenu(event, optionmenu) {
    const hasClass = this.closeOptionMenu(event, optionmenu);
    if (!hasClass) optionmenu.classList.add('active');
  }

  public closeOptionMenu(event, optionmenu): boolean {
    event.stopPropagation();
    const hasClass = optionmenu.classList.contains('active');
    this.optionmenus.map(z => z.nativeElement.classList.remove('active'));
    return hasClass;
  }

  public openOptionDialog(productId, event, title): void {
    event.stopPropagation();
    let dialogRef = this.dialog.open(DialogArchiveItemComponent, {
      data: {
        productId,
        title
      }
    });

    dialogRef.afterClosed.subscribe(res => {
      if (res?.remove) {
        this.removeItem(res.productId);
        return;
      }
    })
  }
  private getList(showNotif = false) {
    this.http.post('/api/library/archive/list', {}).subscribe(c => {
      let items: Array<any> = c.items;
      this.Items = [];
      items.map(z => this.Items.push(z.product));
      this.filterChange('');
      this.indicator.hide();
      this.indicator.hideHude();
      if (showNotif)
        this.onShowNotification({ text: 'از لیست بایگانی حذف شد', type: 'info' });
    })
  }

  private removeItem(productId) {
    this.indicator.showHude();
    this.log.logger('delete item = ' + productId);
    this.http.post(`/api/library/unarchive/${productId}`, {})
      .subscribe((results: any) => {
        this.log.logger('removed item from db');
        this.log.logger(results);
        try {
          this.device.refreshTabWishlistAndarchiveNative('purchase');
        } catch (error) {
          this.eventTracker.logEvent('x_NOT_FOUND_METHOD_IN_NATIVE', { location_screen: 'archive', x_method_name: 'getUnarchived' });
        }
        this.getList(true);
      }, err => {
        this.indicator.showHude();
        if (err.error && err.error.message)
          this.onShowNotification({ text: err.error.message, type: 'error' });
        else
          this.onShowNotification({ text: 'در حذف بایگانی خطایی رخ داد. لطفا دوباره تلاش کنید', type: 'error' });
      });
  }

  public filterItems(searchText: string, contentType: number) {
    this.searchText = searchText;
    return this.Items.filter(it => {
      let res;
      if (searchText) {
        res = it["audioBook"].title.toLowerCase().includes(searchText) && it["audioBook"].contentType == contentType;
      } else {
        res = it["audioBook"].contentType == contentType;
      }
      return res;
    });
  }

  public filterChange(searchText: string) {
    for (let i = 0; i <= 3; i++) {
      this.log.logger(i);
      this.FilteredItems[i] = this.filterItems(searchText, i);
      this.dataBadge[i] = this.FilteredItems[i].length;
    }
    this.log.logger(this.FilteredItems);
  }
}
